module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tenders/tenders-create/tenders-create.component.css
// module id = ./src/app/components/tenders/tenders-create/tenders-create.component.css
// module chunks = main